/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import cs from 'classnames';

import Icon from 'shared/components/presentational/Icons';

// eslint-disable-next-line react/prefer-stateless-function
export default class Arrow extends React.PureComponent {
  render() {
    const { className, style, onClick, theme = 'default' } = this.props;
    const classes = cs(className, `Arrow--${theme}`);
    return (
      <button className={classes} style={style} onClick={onClick}>
        <Icon name="Menu" width={10} height={20} />
      </button>
    );
  }
}
